export default __webpack_public_path__ + "static/media/CAV parameters.4af5b78d.pdf";